import { render, staticRenderFns } from "./QuotePartsControlNotOrdered.vue?vue&type=template&id=2253d83c&scoped=true"
import script from "./QuotePartsControlNotOrdered.vue?vue&type=script&lang=js"
export * from "./QuotePartsControlNotOrdered.vue?vue&type=script&lang=js"
import style0 from "./QuotePartsControlNotOrdered.vue?vue&type=style&index=0&id=2253d83c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2253d83c",
  null
  
)

export default component.exports